/* Sunucudaki Core.Helpers.PasswordOperations.PasswordPolicy kuralının ekran karşılığı.

   Kural bilerek regex ile yazılmadı. /[A-Z]/ yalnız ASCII harfleri tanır; sunucu tarafı
   ise Char.IsUpper kullandığı için "Şifre123" gibi Türkçe karakterli bir parolayı kabul
   eder. Regex kullanılsaydı sunucunun kabul ettiği parola ekranda reddedilir, kullanıcı
   hiçbir açıklaması olmayan bir duvara çarpardı. Unicode özellik kaçışları (\p{Lu})
   bu sorunu çözerdi ama eski tarayıcılarda derlenmez; toLowerCase/toUpperCase
   karşılaştırması her yerde çalışır ve Char.IsUpper/IsLower ile aynı kararı verir. */

export const MIN_LENGTH = 8
export const MAX_LENGTH = 128

const isUpper = ch => ch !== ch.toLowerCase() && ch === ch.toUpperCase()
const isLower = ch => ch !== ch.toUpperCase() && ch === ch.toLowerCase()
const isDigit = ch => ch >= '0' && ch <= '9'

/**
 * Parola kuralı sağlanıyorsa null, sağlanmıyorsa kullanıcıya gösterilecek mesajı döner.
 * Mesajlar sunucudaki karşılıklarıyla birebir aynıdır.
 */
export function validatePassword(password){
    if(!password || !password.trim()) return 'Parola boş bırakılamaz.'
    if(password.length < MIN_LENGTH) return `Parola en az ${MIN_LENGTH} karakter olmalıdır.`
    if(password.length > MAX_LENGTH) return `Parola en fazla ${MAX_LENGTH} karakter olabilir.`

    const chars = Array.from(password)
    if(!chars.some(isUpper)) return 'Parola en az bir büyük harf içermelidir.'
    if(!chars.some(isLower)) return 'Parola en az bir küçük harf içermelidir.'
    if(!chars.some(isDigit)) return 'Parola en az bir rakam içermelidir.'

    return null
}
